import { PortalSandboxPage } from "../../../components/gov/PortalSandboxPage";
import { MUQEEM_CONFIG } from "../../../components/gov/portalConfigs";

export function MuqeemPortalPage() {
  return <PortalSandboxPage config={MUQEEM_CONFIG} />;
}

export default MuqeemPortalPage;
